export const getAssetsApi = (params, query) => {
  const { asset_id, ...rest } = query || {};
  const urlParams = new URLSearchParams();

  Object.entries(rest).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    urlParams.set(key, value);
  });

  let queryString = urlParams.toString();
  if (asset_id?.length) {
    const assetFilter = Array.isArray(asset_id) ? asset_id : asset_id.toString().split(',').filter(Boolean);
    const assetParam = `asset_id=[${assetFilter.join(',')}]`;
    queryString = queryString ? `${queryString}&${assetParam}` : assetParam;
  }

  return `/lease/asset-list${queryString ? `?${queryString}` : ''}`
}

export const getAircraftTypeList = () => {
  return `/console/aircraft-types/`
}

export const getEngineTypeList = () => {
  return `/config/engine-types/`
}

export const getApuTypeList = () => {
  return `/console/apu-types/`
}